<template>
    <div>
        <div class="">
             <div v-if="errors.length !== 0" class="alert alert-error rich-text -mb-4">
                <div v-for="(v, k) in errors" :key="k">
                    <p v-for="error in v" :key="error" class="">
                        {{ error }}
                    </p>
                </div>
            </div>

            <div v-for="(sluzba, i) in sluzby" :key="i" class="mt-11 first:mt-5">
                <div class="md:flex items-start">
                    <select v-model="sluzba.id_sluzby" @change="vyberSluzbu(i, $event)" :name="'sluzby[' + i + '][id_sluzby]'" class="flex-none form-select form-control w-full" :class="sluzba.nazev ? 'md:w-3/5' : ''">
                        <option value="">{{ trans.get('rezervace.typ_vychozi') }}</option>
                        <option v-for="dostupnaSluzba in dostupneSluzby" :key="dostupnaSluzba.id_sluzby" :value="dostupnaSluzba.id_sluzby" :disabled="dostupnaSluzba.volnych == 0 || dostupnaSluzba.turnusy != null || dostupnaSluzba.min_pocet_noci != null">
                            {{ dostupnaSluzba.nazev }}
                            <template v-if="dostupnaSluzba.turnusy != null">
                                ({{ trans.get('rezervace.typ_turnusy', { den: dostupnaSluzba.turnusy.den, od: dostupnaSluzba.turnusy.od, do: dostupnaSluzba.turnusy.do }) }})
                            </template>
                            <template v-else-if="dostupnaSluzba.min_pocet_noci != null">
                                ({{ trans.get('rezervace.typ_min_pocet_noci', { min_pocet_noci: dostupnaSluzba.min_pocet_noci.noci, od: dostupnaSluzba.min_pocet_noci.od, do: dostupnaSluzba.min_pocet_noci.do }) }})
                            </template>
                            <template v-else>
                                ({{ trans.choice('rezervace.typ_volnych', dostupnaSluzba.volnych, { pocet: dostupnaSluzba.volnych }) }})
                            </template>
                        </option>
                    </select>

                    <div v-on-clickaway="zavriOkno" @click.stop class="relative w-full md:w-2/5 mt-4 md:mt-0 md:ml-4" :class="sluzba.nazev ? 'md:w-2/5' : 'hidden'">
                        <div @click="sluzba.okno = !sluzba.okno" class="px-3 py-2 border border-gray-300 rounded-3 truncate cursor-pointer" :class="sluzba.okno ? 'border-blue-500' : ''">
                            <span v-for="(skupina, j) in sluzba.vekove_skupiny" :key="j">
                                <span :class="j > 0 ? 'ml-3' : ''">{{ skupina.pocet }} <span class="inline align-baseline">&times;</span> {{ skupina.nazev }} <span class="text-12 text-gray-400">{{ skupina.vek_od }}-{{ skupina.vek_do }}</span></span>
                            </span>
                        </div>

                        <div v-show="sluzba.okno" class="absolute z-10 right-0 md:right-22 top-0 mt-12 p-4 md:p-6 bg-white rounded-3 shadow-lg space-y-4">
                            <div v-for="(skupina, j) in sluzba.vekove_skupiny" :key="j" class="flex items-center">
                                <input type="hidden" :name="'sluzby[' + i + '][vekove_skupiny][' + j + '][id_vekove_skupiny]'" :value="skupina.id_vekove_skupiny">

                                <div class="w-32">
                                    <div class="font-semibold">{{ skupina.nazev }}</div>
                                    <div class="text-13 text-gray-500">{{ skupina.vek_od }}-{{ skupina.vek_do }} let</div>
                                </div>

                                <div class="flex">
                                    <button @click.prevent="skupina.pocet > 0 ? skupina.pocet = Number(skupina.pocet) - 1 : false; spocitejCenu(sluzba)" class="flex justify-center items-center w-10 bg-gray-100 rounded-l-3">-</button>
                                    <input v-model="skupina.pocet" @keyup="spocitejCenu(sluzba)" type="text" :name="'sluzby[' + i + '][vekove_skupiny][' + j + '][pocet]'" class="form-input form-control w-12 py-1.5 text-center rounded-none" autocomplete="off">
                                    <button @click.prevent="skupina.pocet = Number(skupina.pocet) + 1; spocitejCenu(sluzba)" class="flex justify-center items-center w-10 bg-gray-100 rounded-r-3">+</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="sluzba.nazev" class="md:flex items-start mt-6">
                    <div class="flex-none md:w-48">
                        <img :src="sluzba.obrazek_url" :alt="sluzba.nazev" class="md:w-48 md:h-32 object-cover">
                    </div>

                    <div class="flex-1 md:flex items-start">
                        <div class="flex-1 md:ml-8 mt-4 md:-mt-0.75">
                            <div class="text-18 font-bold md:-mt-0.75">{{ sluzba.nazev }}</div>
                            <div class="mt-1 text-15 leading-relaxed text-gray-500" v-html="sluzba.popis"></div>
                        </div>

                        <div class="flex items-center md:items-start justify-between md:ml-16 mt-4 md:mt-0">
                            <div class="flex-none md:w-40 md:text-right">
                                <div class="text-18 font-bold md:-mt-1.5">{{ sluzba.cena_celkem.toLocaleString('cs-CZ') + ' ' + zkratkaMeny }}</div>
                                <div class="mt-0.5 text-12 text-gray-500">{{ trans.choice('rezervace.typ_noci', pocetNoci, { noci: pocetNoci }) }}</div>

                                <button @click.prevent="odstranSluzbu(i)" class="link mt-4 text-13 text-right">{{ trans.get('rezervace.typ_odstranit') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button @click.prevent="pridejSluzbu" class="w-full py-5.5 mt-11 border-dashed border-2 border-gray-200 hover:border-blue-500 rounded-3 duration-300">{{ trans.get('rezervace.typ_pridat') }}</button>

        <div class="mt-11">
            <div v-if="rezervovat">
                <button class="w-full py-4 text-18 font-semibold text-white bg-blue-500 hover:bg-blue-600 whitespace-nowrap rounded-3 duration-300" type="submit">
                    {{ trans.get('rezervace.typ_tlacitko', { cena: mena(cenaRezervace) + ' ' + zkratkaMeny }) }}
                </button>
            </div>
            <div v-else>
                <div class="w-full py-4 text-18 font-semibold text-white text-center bg-blue-300 rounded-3 duration-300 cursor-not-allowed">
                    {{ trans.get('rezervace.typ_tlacitko', { cena: mena(cenaRezervace) + ' ' + zkratkaMeny }) }}
                </div>
            </div>
        </div>

        <div v-if="rezervovat" class="mt-8 text-center text-15">* {{ cenaInfo }}</div>
    </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
    mixins: [ clickaway ],

    props: {
        initSluzby: Array,
        dostupneSluzby: Array,
        vekoveSkupiny: Array,
        cenaInfo: String,
        pocetNoci: Number,
        vyseZalohy: Number,
        zkratkaMeny: String,
        errors: [Object, Array],
    },

    data: function () {
        return {
            sluzby: [],
        }
    },

    methods: {
        pridejSluzbu() {
            this.sluzby.push(this.nactiSluzbu());
        },

        odstranSluzbu(i) {
            this.sluzby.splice(i, 1);
        },

        vyberSluzbu(i, event) {
            this.$set(this.sluzby, i, this.nactiSluzbu(event.target.value, this.sluzby[i].vekove_skupiny))
        },

        zavriOkno() {
            this.sluzby.forEach(sluzba => sluzba.okno = false);
        },

        nactiSluzbu(id_sluzby = null, vekove_skupiny = []) {
            let dostupnaSluzba = this.dostupneSluzby.find(sluzba => sluzba.id_sluzby === Number(id_sluzby));
            dostupnaSluzba = dostupnaSluzba ? JSON.parse(JSON.stringify(dostupnaSluzba)) : dostupnaSluzba;

            let sluzba = {};
            if (dostupnaSluzba) {
                sluzba.id_sluzby = id_sluzby;
                sluzba.nazev = dostupnaSluzba.nazev;
                sluzba.popis = dostupnaSluzba.popis;
                sluzba.obrazek_url = dostupnaSluzba.obrazek_url;
                sluzba.cena_sluzba = dostupnaSluzba.cena_sluzba;
                sluzba.okno = false;

                vekove_skupiny.forEach(vekova_skupina => {
                    let dostupnaSkupina = dostupnaSluzba.vekove_skupiny.find(dostupnaSkupina => dostupnaSkupina.id_vekove_skupiny === Number(vekova_skupina.id_vekove_skupiny));
                    vekova_skupina.cena_za_osobu = dostupnaSkupina.cena_za_osobu;
                });
                sluzba.vekove_skupiny = vekove_skupiny.length > 0 ? vekove_skupiny : dostupnaSluzba.vekove_skupiny;

                sluzba.vekove_skupiny.forEach(vekova_skupina => {
                    let skupina = this.vekoveSkupiny.find(skupina => skupina.id_vekove_skupiny === Number(vekova_skupina.id_vekove_skupiny));
                    vekova_skupina.nazev = skupina.nazev;
                    vekova_skupina.vek_od = skupina.vek_od;
                    vekova_skupina.vek_do = skupina.vek_do;
                });

                this.spocitejCenu(sluzba);
            } else {
                sluzba.id_sluzby = '';
                sluzba.nazev = '';
                sluzba.popis = '';
                sluzba.obrazek_url = '';
                sluzba.cena_sluzba = 0;
                sluzba.cena_osoby = 0;
                sluzba.cena_celkem = 0;
                sluzba.vekove_skupiny = [];
            }

            return sluzba;
        },

        spocitejCenu(sluzba) {
            let cena_osoby = 0;
            sluzba.vekove_skupiny.forEach(function (skupina) {
                cena_osoby += skupina.cena_za_osobu * (skupina.pocet ?? 0);
            })

            sluzba.cena_osoby = cena_osoby;
            sluzba.cena_celkem = sluzba.cena_sluzba + sluzba.cena_osoby;
        },

        mena(castka) {
            return castka.toLocaleString('cs-CZ');
        },
    },

    computed: {
        rezervovat: function () {
            return (this.sluzby.length > 0) && (this.sluzby.filter(sluzba => sluzba.nazev).length > 0);
        },

        cenaRezervace: function () {
            let cena_rezervace = 0;
            this.sluzby.forEach((sluzba) => cena_rezervace += sluzba.cena_celkem);

            return cena_rezervace;
        },

        zaloha: function () {
            return Math.round(this.cenaRezervace * (this.vyseZalohy / 100));
        },
    },

    created() {
        if (this.initSluzby) {
            this.initSluzby.forEach((sluzba) => this.sluzby.push(this.nactiSluzbu(sluzba.id_sluzby, sluzba.vekove_skupiny)));
        }

        if (this.sluzby.length === 0) {
            this.pridejSluzbu();
        }
    }
}
</script>
